import React from "react";

import { Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  contentTitle: {
    marginBottom: theme.spacing(2),
  },
}));

const ConnectInstruction = () => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="body1" className={classes.contentTitle}>
        Чтобы подключить терминал iiko к&nbsp;Личному кабинету GuestMe:
      </Typography>
      <Typography variant="body1">
        1. Перейдите в&nbsp;меню «Дополнения» на&nbsp;терминале iikoFront
      </Typography>
      <Typography variant="body1">
        2. В&nbsp;появившемся окне выберите «GuestMe» и&nbsp;введите
        сгенерированный ниже ПИН-код.
      </Typography>
    </>
  );
};

export default ConnectInstruction;
